import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
/**
 * Scrolls the window to the top
 * @return {void}
 */
export function scrollToTop() {
    const xCoordinate = 0;
    const yCoordinate = 0;
    const body = document.querySelector('body');
    const contentWrapper = document.getElementById('uc-content-container');

    window.scrollTo(xCoordinate, yCoordinate);
    body.scrollTo(xCoordinate, yCoordinate);
    contentWrapper.scrollTo(xCoordinate, yCoordinate);
}

/**
 * Returns the browser history location pathname.
 * @returns {String} The pathname
 */
export function getBrowserHistoryPathname() {
    return window.location.pathname;
}

/**
 * Returns the host name
 * @return {String} The host name
 */
export function getHostName() {
    return window.location.hostname;
}

/**
 * Navigates away
 * @param {String} url The url to navigate to
 * @return {void}
 */
export function navigateAway(url) {
    window.location.href = url;
}

/**
 * Go back
 * @return {void}
 */
export function navigateBack() {
    window.history.back();
}

/**
 * Register a handler for popstate events
 * @param  {Function} callback A callback that receives the state object on popstate event
 * @return {Function} A callback to stop listening to the popstate event
 */
export function onPopState(callback) {

    const onPopState = (event) => {
        let { state } = event;
        state = (isUndefined(event.state) || isNull(event.state)) ? {} : event.state;

        callback(state);
    };

    window.addEventListener('popstate', onPopState);

    return function offPopState() {
        window.removeEventListener('popstate', onPopState);
    };
}

/**
 * Scroll to horizontal to an element
 * @param  {Element} element The element to scroll to
 * @param  {Element} [parent=Document] The element's parent which will be scrolled
 * @return {void}
 */
export function scrollHorizontallyTo(element, parent = document) {
    parent.scrollLeft = element.offsetLeft - window.innerWidth + element.offsetWidth;
}

/**
 * Checks if the element is fully visible
 * @param  {Element} element The element
 * @return {Boolean} A boolean value indicating if the element is fully visible or not
 */
export function elementIsFullyVisible(element) {
    const box = element.getBoundingClientRect();
    const startPosition = 0;

    return !(
        box.bottom < startPosition ||
        box.right < startPosition ||
        box.top < startPosition ||
        box.left < startPosition ||
        (box.left + box.width) > window.innerWidth ||
        (box.top + box.height) > window.innerHeight
    );
}

/**
 * Checks if the element is visible. This will return even if part of the element is hidden
 * @param  {Element} element The element
 * @return {Boolean} A boolean value indicating if the element is visible or not
 */
export function elementIsVisible(element) {
    const box = element.getBoundingClientRect();
    const startPosition = 0;

    return !(box.bottom < startPosition || box.right < startPosition || box.left > window.innerWidth || box.top > window.innerHeight);
}

/**
 * Subscribes a callback to touch move event on an element
 * @param {Function} moveLeft The on move left callback
 * @param {Function} moveRight The on move right callback
 * @param {Element} [el=document] Optional element. Default is the document
 * @return {Function} A function to unsubscribe from the event
 */
export function onTouchMove({moveLeft, moveRight, el = document}) {
    let touchStartX = NaN;
    let touchEndX = NaN;
    const touchIndex = 0;

    /**
     * Handles touch start event on the element
     * @param {Event} e The event object
     * @return {void}
     */
    function onTouchStart(e) {
        const touch = e.touches[touchIndex];
        touchStartX = touch.clientX;
    }

    /**
     * Handles touch move event on the element
     * @param {Event} e The event object
     * @return {void}
     */
    function onTouchMove(e) {
        const touch = e.touches[touchIndex];
        touchEndX = touch.clientX;
    }

    /**
     * Handles touch end event on the element
     * @param {Event} e The event object
     * @return {void}
     */
    function onTouchEnd(e) {
        if (!window.isNaN(touchStartX) && !window.isNaN(touchEndX)) {
            const data = { e, touchStartX, touchEndX };
            if (touchStartX > touchEndX) {
                moveLeft(data);
            } else {
                moveRight(data);
            }
        }

        window.dataLayer.push({
            'event': 'SP_SWIPE',
            'gtm.element': el,
        });

        touchStartX = NaN;
        touchEndX = NaN;
    }

    el.addEventListener('touchstart', onTouchStart);
    el.addEventListener('touchmove', onTouchMove);
    el.addEventListener('touchend', onTouchEnd);

    return function unsubscribe() {
        el.removeEventListener('touchstart', onTouchStart);
        el.removeEventListener('touchmove', onTouchMove);
        el.removeEventListener('touchend', onTouchEnd);
    };
}

/**
 * Find first scrollable parent
 * @param {Object} e dom object
 * @return {Object} scrollable parent
 */
export function getScrollParent(e) {
    let parent = window;
    let element = e;
    if (element !== window) {
        for (; element && element !== document.body; ) {
            const style = window.getComputedStyle(element) || {}, overflowY = style.overflowY;
            if (['auto', 'scroll'].includes(overflowY)) {
                parent = element;
                break;
            }
            element = element.parentElement;
        }
    }

    return parent;
}

/**
 * Calculate scroll top of specific element
 * @param {Object} element dom object
 * @return {Number} scroll top
 */
export function getScrollTop(element) {
    return element === window ? element.pageYOffset : element.scrollTop;
}

/**
 * Checks if IE
 * @return {Boolean} true if version of IE is 10 or 11
 */
export function isIE() {
    const userAgent = window.navigator.userAgent;
    const notExist = -1;

    return userAgent.indexOf('MSIE ') !== notExist || userAgent.indexOf('Trident/') !== notExist;
}
